import QCService from 'src/services/quickChecks'
import QuickCheck from 'src/models/ActionPlan.model'

export default {
  async getTemporaryQC () {
    let data = []
    await QCService.getTemporaryQC()
      .then(res => {
        data = res
      })

    return data
  },
  putRestoredQC (payload) {
    this.newQuickCheck = payload
  },
  updateQCTasks (payload) {
    this.newQuickCheck.tasks = payload
  },
  reseteNewQuickCheck () {
    this.newQuickCheck = {
      name: null,
      location_id: [],
      role_id: null,
      assigned_to: null,
      priority: 1,
      end_date: null,
      tasks: []
    }
  },
  async createQC () {
    const obj = {
      ...this.newQuickCheck,
      location_id: this.newQuickCheck.location_id[0]
    }

    const promise = await QCService.createQC(obj)
      .then(async () => {
        await QCService.deleteTemporary()
      })

    return promise
  },
  addTasksToQC (payload) {
    const obj = {
      tasks: this.newQuickCheck.tasks,
      end_date: payload.endDate,
      id: payload.id
    }
    const promise = QCService.addTasksToQC(obj)

    return promise
  },
  fetchFiltered (options) {
    const payload = {
      limit: 15,
      page: 1,
      ...options
    }
    const promise = QCService.fetchFiltered(payload)

    promise
      .then(response => {
        this.quickChecks = response.data.map(quickCheck => {
          return new QuickCheck(quickCheck)
        })
  
        this.pagination = {
          page: payload.page,
          rowsPerPage: payload.limit,
          rowsNumber: response.total
        }
      })
      .catch(error => {
        console.error(error)
      })

    return promise
  },
  updateTaskTitle (payload) {
    this.newQuickCheck.tasks[payload.index].title = payload.title
  },
  updateQCName (name) {
    this.newQuickCheck.name = name
  },
  updateQCLocations (locations) {
    this.newQuickCheck.location_id = locations
  },
  updateQCRole (role) {
    this.newQuickCheck.role_id = role
  },
  updateQCUsers (users) {
    this.newQuickCheck.assigned_to = users
  },
  updateQCEndDate (endDate) {
    this.newQuickCheck.end_date = endDate
  },
  updateQCStartDate (startDate) {
    this.newQuickCheck.start_date = startDate
  },
  updateQCPriority (priority) {
    switch (priority) {
      case 'Alta':
        priority = 3
        break
      case 'Media':
        priority = 2
        break
      case 'Baja':
        priority = 1
        break
      default:
        priority = null
        break
    }

    this.newQuickCheck.priority = priority
  },
  quickCheckEdit (payload) {
    const promise = QCService.quickCheckEdit(payload)

    return promise
  }
}
